import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, Tabs, Tab, Alert } from '@mui/material';
import { CardContainer, TabPanel } from '../shared';
import LiquidacionesTab from './LiquidacionesTab';
import MaestrosTab from './MaestrosTab';

const PescaPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const { empresaActiva } = useSelector(state => state.empresa);

  const subheader = empresaActiva
    ? `Gestión de liquidaciones de pesca - ${empresaActiva.nombre_corto || empresaActiva.razon_social}`
    : undefined;

  return (
    <Container maxWidth="xl">
      {!empresaActiva && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Debe seleccionar una empresa para acceder a Pesca.
        </Alert>
      )}

      <CardContainer
        title="Liquidaciones de Pesca"
        subheader={subheader}
        cardProps={{ sx: { width: '100%', mb: 3 }, elevation: 1 }}
        headerProps={{ sx: { pb: 0 }, component: 'div' }}
        contentProps={{ sx: { p: 0 } }}
      >
        <Tabs
          value={tabValue}
          onChange={(e, v) => setTabValue(v)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Liquidaciones" />
          <Tab label="Maestros" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <LiquidacionesTab />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <MaestrosTab />
        </TabPanel>
      </CardContainer>
    </Container>
  );
};

export default PescaPage;
